module.exports = __webpack_public_path__ + "img/voicebannerimg.7eb93cce.png";